import UpdatePageFromUrl from "./updatepagefromurl.js";
import FilterMenu from "./filtermenu.js";
import UpdateFilterUrl from "./updatefilterurl.js";
import FilterValues from "./filtervalues.js";
import { prodListValues } from './shared.js';

const mobileFilterDropDown = document.getElementById('filterDropDown');

let eventsInitialized = false;
let pagerEventInitialized = false;

class EventListeners {
    /**
     * Initializes event listeners for the product listing page, including filter changes, sorting, pagination, and browser history navigation.
     * @return {void}
     */
    init() {
        events();
        pagerEvent();
    }
}

/**
 * Initializes event listeners for various user interactions on the product listing page.
 * @return {void}
 */
function events() {
    if (eventsInitialized) return;
    eventsInitialized = true;

    document.getElementById('filterDropDown').addEventListener('click', function (e) {
        e.preventDefault();

        // remove the top positioning that is added on mobile when the filter is opened
        const filterDropdownMenu = document.getElementById('menuContainer');
        if(filterDropdownMenu.hasAttribute("style")) filterDropdownMenu.removeAttribute("style");

        if (this.classList.contains('active')) {
            this.parentElement.classList.remove('active');
            FilterMenu.unSelectMainMenu(this);
            if (document.querySelector(".openedFilter")) {
                document.querySelector(".openedFilter").setAttribute("aria-expanded", "false");
                document.querySelector(".openedFilter").classList.remove("openedFilter");
            }
            this.focus();
        } else {
            this.parentElement.classList.add('active');
            FilterMenu.selectMainMenu(this);
            FilterMenu.addTagFilters();
        }
    });

    document.getElementById('filterDropDown').addEventListener('keydown', function (e) {
        if (e.which === 9 && !e.shiftKey && this.classList.contains('active')) {
            e.preventDefault();

            let menu = document.getElementById('filterMenuMobile');

            if (menu.classList.contains('hide')) {
                FilterMenu.openMenuOption.querySelector('.filterMenuSelect').focus();
            } else {
                let listItems = document.getElementById('filterMenuMobile').querySelectorAll('li:not(.hide)');

                if (listItems.length) {
                    listItems[0].children[0].focus();
                }
            }
        }
    });

    document.getElementById('sortDropDown').addEventListener('change', function (e) {
        FilterMenu.setFilterOrder(this.value);
        UpdateFilterUrl.update(FilterValues, prodListValues, true);
    });

    document.getElementById('sortDropDown').addEventListener('click', function (e) {
        FilterMenu.unSelectMainMenu(document.getElementById(this.getAttribute('data-disable-id')));
    });

    document.getElementById('itemsPerPageDropDown').addEventListener('change', function (e) {
        FilterValues.addPageSize(this.value);
        FilterValues.addPageNumber(1);
        UpdateFilterUrl.update(FilterValues, prodListValues, true, true, true);
    });

    document.getElementById('toggleFilterSideBar').addEventListener('click', (e) => FilterMenu.toggleFilterOptions(e));

    const toggleTagFilters = document.getElementById('toggleTagFilters');
    toggleTagFilters && toggleTagFilters.addEventListener('click', (e) => FilterMenu.toggleTagFilters(e));

    window.onpopstate = function (event) {
        if (event.state !== null) {
            document.title = event.state.title;
            document.querySelector('meta[name="description"]').setAttribute('content', event.state.description);
        } else {
            document.title = '';
            document.querySelector('meta[name="description"]').setAttribute('content', '');
        }

        if (mobileFilterDropDown.classList.contains('active')) {
            FilterMenu.unSelectMainMenu(mobileFilterDropDown);
        }

        UpdatePageFromUrl.update();

        UpdateFilterUrl.update(FilterValues, prodListValues, true, false, true);
    };
}

/**
 * Initializes event listeners for pagination links on the product listing page.
 * @return {void}
 */
function pagerEvent() {
    if (pagerEventInitialized) return;
    pagerEventInitialized = true;

    document.addEventListener('click', function (e) {
        const pagerLink = e.target.closest('.pagerLink');
        if (!pagerLink) return;

        e.preventDefault();
        const pageNumber = pagerLink.getAttribute('data-page-number');

        if (!isNaN(pageNumber)) {
            document.getElementById('mainContent').scrollIntoView({ behavior: 'smooth' });
            FilterValues.addPageNumber(pageNumber);
            UpdateFilterUrl.update(FilterValues, prodListValues, true);
        }
    });
};

export default new EventListeners();